export default {
  setSipParam(state, value) {
    state.sipParam = value
  },
  setSipParams(state, value) {
    state.sipParams = value
  },
  setIncomingUser(state, value) {
    state.incomingUser = value
  },
  setOutgoingUser(state, value) {
    state.outgoingUser = value
  },
  setSipHistory(state, value) {
    state.sipHistory = value
  },
  setIncomingCall(state, value) {
    state.isIncomingCall = value
  },
  setModalOpen(state, value) {
    state.isModalOpen = value
  },
  setOpenedSession(state, value) {
    state.isOpenedSession = value
  },
  setInCall(state, value) {
    state.isInCall = value
  },
  setPhone(state, value) {
    state.phone = value
  },
  setIncomingPhone(state, value) {
    state.incomingPhone = value
  },
  setSipHistoryComments(state, value) {
    state.sipHistoryComments = value
  },
  appendSipHistoryComment(state, comment) {
    state.sipHistoryComments.unshift(comment)
  },
  setIsCommentsLoaded(state, value) {
    state.isCommentsLoaded = value
  },
}
